import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { Config } from '@features/termination/interfaces';

export enum ConfigActionType {
  CONFIG_LOAD = '[Config] Config Load',
  CONFIG_LOAD_COMPLETE = '[Config] Config Load Complete',
  CONFIG_LOAD_ERROR = '[Config] Config Load Error',
}

export const ConfigLoad = createAction(ConfigActionType.CONFIG_LOAD);

export const ConfigLoadComplete = createAction(
  ConfigActionType.CONFIG_LOAD_COMPLETE,
  props<{ config: Config }>(),
);

export const ConfigLoadError = createAction(
  ConfigActionType.CONFIG_LOAD_ERROR,
  props<{ error?: HttpErrorResponse }>(),
);
